import * as React from 'react';
import {
    ShowButton,
    List,
    Datagrid,
    TextField,
    EditButton,
    TextInput,
    Filter,
} from 'react-admin';

const AzureAuthenticationFilter = props => (
    <Filter {...props}>
        <TextInput label="Search" source="q" />
    </Filter>
);

const AzureAuthenticationList = props => (
    <List {...props} filters={<AzureAuthenticationFilter />}>
        <Datagrid>
            <TextField source="id" />
            <TextField source="name" />
            <TextField source="client_id" label="Client ID" />
            <TextField source="tenant_id" label="Tenant ID" />
            <TextField source="subscription_id" label="Subscription ID" />
            <EditButton />
            <ShowButton />
        </Datagrid>
    </List>
);

export default AzureAuthenticationList;